import { connect } from "react-redux";
import ChartWrapper from "./ChartWrapper";


const mapStateToProps = (state) => ({

});

const mapDispatchToProps = (dispatch) => ({

});

export default connect(mapStateToProps, mapDispatchToProps)(ChartWrapper);
